"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeAllRegisteredListeners = exports.removeRegisteredListener = exports.registerListener = exports.eventListeners = exports.removeEventListener = exports.addEventListener = exports.isMsEdge = exports.isIE11 = exports.ifBrowserThen = exports.safeAction = exports.detectDevice = exports.browserVersion = exports.isSupported = exports.isUserAgentBot = exports.isTouchScreenDevice = exports.isMobileApple = exports.isSafari = void 0;

var _bowser = _interopRequireDefault(require("bowser"));

var _misc = require("../misc");

/**
 * Checks if user's browser is Safari
 * @param navigator object from window
 */
var isSafari = function isSafari(navigator) {
  return Boolean(_bowser["default"].detect(navigator.userAgent).safari);
};
/**
 * Checks if user's browser is mobile Safari (iPhone or iPod)
 * @param navigator object from window
 */


exports.isSafari = isSafari;

var isMobileApple = function isMobileApple(navigator) {
  return navigator.platform === "iPhone" || navigator.platform === "iPod";
};
/**
 * Checks if user's browser supports touchscreen events
 */


exports.isMobileApple = isMobileApple;

var isTouchScreenDevice = function isTouchScreenDevice() {
  return (0, _misc.isBrowser)() && "ontouchstart" in document.documentElement;
};
/**
 * Determine if user agent is a BOT or phantomJS headless browser
 * @param userAgent
 */


exports.isTouchScreenDevice = isTouchScreenDevice;

var isUserAgentBot = function isUserAgentBot(userAgent) {
  return /bot|bingbot|googlebot|crawler|spider|robot|crawling|phantomjs/i.test(userAgent);
};
/**
 * Checks if the env is a Browser and if the key exists in 'window'
 */


exports.isUserAgentBot = isUserAgentBot;

var isSupported = function isSupported(key) {
  return (0, _misc.isBrowser)() && !!window[key];
};
/**
 * Gets a version of user's browser
 * @param navigator object from window
 */


exports.isSupported = isSupported;

var browserVersion = function browserVersion(navigator) {
  var version = String(_bowser["default"].detect(navigator.userAgent).version);
  return Number(version.substr(0, 2));
};
/**
 * Detects whether user visited a website on `mobile`, `tablet` or `desktop`.
 * Examples:
 * @param userAgent
 */


exports.browserVersion = browserVersion;

var detectDevice = function detectDevice(userAgent) {
  var browser = _bowser["default"].detect(userAgent);

  if (browser.mobile) {
    return "mobile";
  }

  if (browser.tablet) {
    return "tablet";
  }

  return "desktop";
};
/**
 * Makes an actions safe. For example, if we're manipulating a window's property
 * @example
 * // UNSAFE
 * const action = () => window.localStorage.getItem('test');
 *
 * action();
 *
 * // SAFE
 * const validator = () => typeof window === 'object' // same as const validator = isBrowser
 * const action = safeAction(validator, () => window.localStorage.getItem('test'));
 *
 * action();
 */


exports.detectDevice = detectDevice;

var safeAction = function safeAction(validator, handler) {
  return function () {
    if (validator()) {
      try {
        return handler.apply(void 0, arguments);
      } catch (err) {
        console.error("Error trying to perform a safe action", err);
      }
    }

    return undefined;
  };
};
/**
 * Wrapper that only runs the provided funtion if isBrowser returns true
 */


exports.safeAction = safeAction;

var ifBrowserThen = function ifBrowserThen(fn) {
  return safeAction(_misc.isBrowser, fn);
};
/**
 * Checks if user's browser is IE-11
 * @param navigator object from window
 */


exports.ifBrowserThen = ifBrowserThen;

var isIE11 = function isIE11(navigator) {
  var _bowser$detect = _bowser["default"].detect(navigator.userAgent),
      name = _bowser$detect.name,
      version = _bowser$detect.version;

  return String(name).toLowerCase().indexOf("internet explorer") > -1 && String(version).indexOf("11.") === 0;
};
/**
 * Checks if user's browser is MS-Edge
 * @param navigator object from window
 */


exports.isIE11 = isIE11;

var isMsEdge = function isMsEdge(navigator) {
  return Boolean(_bowser["default"].detect(navigator.userAgent).msedge);
};
/**
 * Wrapper around window.addEventListener that ensures it doesn't get called on the server
 */


exports.isMsEdge = isMsEdge;
var addEventListener = ifBrowserThen(function (type, listener) {
  window.addEventListener(type, listener);
});
/**
 * Wrapper around window.removeEventListener that ensures it doesn't get called on the server
 */

exports.addEventListener = addEventListener;
var removeEventListener = ifBrowserThen(function (type, listener) {
  window.removeEventListener(type, listener);
});
exports.removeEventListener = removeEventListener;
var eventListeners = [];
/**
 * Adds an event listener via addEventListener and pushes it to the eventListeners array
 * @example
 * import { registerListener } from 'acq-utils/lib/Browser';
 * registerListener('click', () => console.log('click'));
 */

exports.eventListeners = eventListeners;
var registerListener = ifBrowserThen(function (type, listener) {
  eventListeners.push({
    type: type,
    listener: listener
  });
  addEventListener(type, listener);
  return {
    listener: listener,
    type: type
  };
});
/**
 * Removes an event listener via removeEventListener and removes it from the eventListeners array
 * @example
 * import { registerListener, removeRegisteredListener } from 'acq-utils/lib/Browser';
 * const clickListener = registerListener('click', () => console.log('click'));
 * removeRegisteredListener(clickListener);
 */

exports.registerListener = registerListener;
var removeRegisteredListener = ifBrowserThen(function (_ref) {
  var type = _ref.type,
      listener = _ref.listener;
  exports.eventListeners = eventListeners = eventListeners.filter(function (l) {
    return l.type !== type && l.listener !== listener;
  });
  removeEventListener(type, listener);
});
/**
 * Removes all event listeners set with registerListener and clears the eventListeners array
 * @example
 * import { registerListener, removeRegisteredListener, removeAllRegisteredListeners } from 'acq-utils/lib/Browser';
 * registerListener('click', () => console.log('click'));
 * registerListener('resize', () => console.log('resize'));
 * removeAllRegisteredListeners();
 */

exports.removeRegisteredListener = removeRegisteredListener;
var removeAllRegisteredListeners = ifBrowserThen(function () {
  eventListeners.forEach(function (listenerMap) {
    var type = listenerMap.type,
        listener = listenerMap.listener;
    removeEventListener(type, listener);
  });
  eventListeners.length = 0;
});
exports.removeAllRegisteredListeners = removeAllRegisteredListeners;